<template>
  <CoreDialog
    v-model="isOpened"
    data-qa="alert_dialog"
    size="sm"
    :title="dialogData.title"
    :persistent="dialogData.persistent"
  >
    <template
      v-if="dialogData.text"
      #default
    >
      <div
        data-qa="alert_dialog_text"
        class="text-body-1 text-secondary--text"
      >
        {{ dialogData.text }}
      </div>
    </template>
    <template #actions>
      <v-btn
        v-if="dialogData.cancel?.text"
        data-qa="alert_dialog_cancel"
        :color="dialogData.confirm?.text ? 'text' : 'primary'"
        text
        @click="handleCancel"
      >
        {{ dialogData.cancel.text }}
      </v-btn>
      <v-btn
        v-if="dialogData.confirm?.text"
        data-qa="alert_dialog_confirm"
        color="primary"
        text
        @click="handleConfirm"
      >
        {{ dialogData.confirm.text }}
      </v-btn>
    </template>
  </CoreDialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import type {
  AlertDialogData,
} from 'src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/types'

const dialogData = ref<AlertDialogData>({
  title: undefined,
  text: undefined,
  cancel: undefined,
  confirm: undefined,
  persistent: false,
})

const isOpened = ref(false)

function open(payload: AlertDialogData = {}) {
  dialogData.value = payload
  isOpened.value = true
}

function close() {
  isOpened.value = false
}

function handleCancel() {
  isOpened.value = false
  dialogData.value?.cancel?.callback?.()
}

function handleConfirm() {
  isOpened.value = false
  dialogData.value?.confirm?.callback?.()
}

defineExpose({
  open,
  close,
})
</script>
